import React from 'react'
import styled from 'styled-components'
import Text from '../../utils/Text'

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const Label = styled.label`
  position: relative;
  border: 1px solid #414141;
  background-color: ${props =>
    props.checked ? '#414141' : '#ffffff'};
  transition: background-color 0.2s ease-in;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  margin-bottom: 10px !important;
`

const Answer = styled.div`
  margin: 20px 10px;
  height: 100%;
  text-align: center;
`

const Title = styled.div`
  span {
    color: ${props => (props.checked ? '#ffffff' : '#414141')};
    transition: color 0.2s ease-in;
    font-family: Muli;
    font-size: 16px;
    font-weight: normal;
    padding: 10px;
  }
`

export default function CheckboxText({
  title,
  value,
  checked,
  onChange,
}) {
  return (
    <Label checked={checked}>
      <HiddenCheckbox
        checked={checked}
        onChange={onChange}
        value={value}
      />
      <Answer>
        <Title checked={checked}>
          <Text id={title} />
        </Title>
      </Answer>
    </Label>
  )
}
